import { BugReportEventType, EndEncounterEventType, FindingEventType, InitEncounterEventType, OrderEventType, PathwayEventType, SnapshotEventType, UpdateEncounterEventType, } from '@app/ehr-emulator-shared';
import { ICONS } from '@app/styles';
export const DEFAULT_CHART_WIDTH = 960;
export const MIN_CHART_WIDTH = 320;
/** Min viewport height for empty timeline in stacked layout. */
export const STACKED_EMPTY_VIEWPORT_MIN_HEIGHT = 48;
/** Full-height timeline (no advisor iframe). */
export const MARGIN = { top: 10, right: 20, left: 44, bottom: 44 };
/** Compact chart when the timeline strip sits above the advisor. */
export const STACKED_CHART_MARGIN = { top: 4, right: 8, left: 28, bottom: 14 };
/** Vertical offset between stacked markers (smaller = more overlap between bubbles). */
export const LANE_STEP = 17;
export const STACKED_LANE_STEP = 11;
export const ICON_DRAW_SIZE = 22;
export const MIN_DURATION_MS = 60_000;
/** Wider cluster window so nearby-in-time events share a vertical stack. */
export const MIN_MARKER_GAP_PX = 34;
export const AXIS_COLOR = '#9aa3b2';
export const TRACK_LINE_COLOR = '#d8dde6';
export const TICK_COLOR = '#b8c0ce';
export const ENCOUNTER_EVENT_TYPE_ICONS = {
    [InitEncounterEventType]: ICONS.advisor_avn_admit.component,
    [EndEncounterEventType]: ICONS.advisor_avn_discharge.component,
    [UpdateEncounterEventType]: ICONS.sync.component,
    [OrderEventType]: ICONS.advisor_v5_addOrder.component,
    [BugReportEventType]: ICONS.advisor_avn_bug.component,
    [PathwayEventType]: ICONS.pathways.component,
    [FindingEventType]: ICONS.variable.component,
    [SnapshotEventType]: ICONS.fileExport.component,
};
//# sourceMappingURL=consts.js.map